import React, { Component } from "react";
import Select from "react-select";
import { Image } from "react-bootstrap";
import { sortBy } from "lodash";
import IconProjects from "../../assets/frontPageIcons/no-of-project.png";
import CostIcon from "../../assets/frontPageIcons/cost-project.png";
import { formatNumberOnDashBoard } from "../../helper";
import { stateWiseProjects } from "../../actions/common.action";
import { setStateDropdownData } from "../front/SectorsWheel/sectorWheel.selector";

class StateResponsive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stateList: [],
      selectedState: null
    };
  }

  componentDidMount() {
    this.getStateWiseData();
  }

  getStateWiseData = async () => {
    let response = await stateWiseProjects();
    if (response && response.status) {
      let _data = sortBy(response.data.data, ["stateName"]);
      this.setState(
        {
          stateList: setStateDropdownData(_data)
        },
        () => this.onStateChanged(_data[0])
      );
    }
  };

  onStateChanged = obj => {
    this.setState({
      selectedState: obj
    });
  };

  render() {
    let { stateList, selectedState } = this.state;
    return (
      <div className="projects-by-responsive-wrapper" id="projects">
        {stateList && (
          <Select
            options={stateList}
            maxMenuHeight={220}
            className="sector-state-selector"
            value={selectedState}
            onChange={this.onStateChanged}
          />
        )}
        {selectedState ? (
          <div className="sector-wise-content-inner sector-wise-responsive">
            <div className="sector-content">
              <div className="stats-wrapper">
                <div className="project-stats">
                  <div className="stats-img">
                    <Image src={IconProjects} alt="Projects" />
                  </div>
                  <div className="sector-stats">
                    <b data-test="project-count">
                      {selectedState.projectCount}
                    </b>{" "}
                    Project(s)
                  </div>
                </div>
                <div className="issue-stats">
                  <div className="stats-img">
                    <Image src={CostIcon} alt="Cost" />
                  </div>
                  <div className="sector-stats">
                    <b data-test="project-investment">
                      {formatNumberOnDashBoard(
                        Number(selectedState.projectCost.toFixed(1)),
                        true,
                        true,
                        "."
                      )}
                    </b>{" "}
                    Project(s) Investment
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default StateResponsive;
